import React from 'react'
import UserNav from '../UserComponents/UserNav'
import UserSidebar from '../UserComponents/UserSidebar'
import DoneTable from '../UserComponents/DoneTable'
const DoneList = () => {
  return (
      <div className=' min-h-screen'>
        <div className='flex'>
          <UserSidebar />
          <div className='w-full'>
            <UserNav />
            <DoneTable />
          </div>
        </div>
      </div>
  )
}

export default DoneList